import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { CashFlowScreen } from '@/features/accounting-reports/cash-flow-screen'
import {
  type StatementSearch,
  statementSearchFrom,
} from '@/features/accounting-reports/monthly-statements-api'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/cash-flow')({
  validateSearch: (search: Record<string, unknown>): StatementSearch => statementSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: CashFlowRoute,
})

function CashFlowRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <CashFlowScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/reports/cash-flow', search: next })
      }
    />
  )
}
